<script setup lang="ts">
import {computed} from "vue";
import {RoleService} from "@/services/RoleService";

interface Props {
  role: string;
}

const props = defineProps<Props>();

const roleService = new RoleService();

const isAllowed = computed(() => roleService.hasRole(props.role));
</script>

<template>
  <slot v-if="isAllowed"/>
</template>